import type { GameClient } from "../net";
import { renderHdVideo, RENDER_API } from "../recap";

// The 10 "how would you describe this run?" themes (match remotion/src/themes.ts).
const THEMES: { id: string; label: string }[] = [
  { id: "domination", label: "Utter Domination" },
  { id: "cracked-case", label: "Cracked the Case" },
  { id: "weather-man", label: "Just Enjoying the Weather Man" },
  { id: "standoff", label: "A Mexican Standoff" },
  { id: "action-packed", label: "Action Packed" },
  { id: "cerebral", label: "Cerebral" },
  { id: "confused", label: "Perpetually Confused" },
  { id: "comedy", label: "A Comedy of Errors" },
  { id: "middle", label: "Middle of the Road" },
  { id: "mta", label: "Got Screwed by the MTA" },
];
const esc = (s: string) => s.replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]!));

export function openHdVideo(client: GameClient) {
  let theme = "domination";
  let busy = false;
  const overlay = document.createElement("div");
  overlay.className = "photo-modal";
  overlay.innerHTML = `
    <div class="photo-sheet">
      <div class="photo-sheet-hd"><span>🎬 HD recap video</span><button class="photo-x" aria-label="Close">✕</button></div>
      ${RENDER_API ? "" : `<div class="photo-empty">The HD renderer isn't connected yet.</div>`}
      <div class="photo-tgt-lbl">HOW WOULD YOU DESCRIBE THIS RUN?</div>
      <div class="ask-photogrid hd-themes">${THEMES.map((t) => `<button class="ask-cat ${t.id === theme ? "on" : ""}" data-th="${t.id}">${esc(t.label)}</button>`).join("")}</div>
      <button class="primary photo-send" id="hd-go" ${RENDER_API ? "" : "disabled"}>🎬 Render video</button>
      <div class="photo-status" id="hd-status"></div>
    </div>`;
  document.body.appendChild(overlay);
  const sheet = overlay.querySelector<HTMLElement>(".photo-sheet")!;
  const statusEl = overlay.querySelector<HTMLElement>("#hd-status")!;
  const goBtn = overlay.querySelector<HTMLButtonElement>("#hd-go")!;
  const close = () => { if (busy) return; overlay.remove(); };
  overlay.addEventListener("click", (e) => { if (e.target === overlay) close(); });
  overlay.querySelector(".photo-x")?.addEventListener("click", close);
  sheet.querySelectorAll<HTMLButtonElement>("[data-th]").forEach((b) => b.addEventListener("click", () => { theme = b.dataset.th!; sheet.querySelectorAll("[data-th]").forEach((x) => x.classList.toggle("on", x === b)); }));
  goBtn.addEventListener("click", async () => {
    if (busy) return;
    busy = true; goBtn.disabled = true; statusEl.textContent = "Starting render…";
    try {
      const url = await renderHdVideo(client, theme, (pct) => { statusEl.textContent = `Rendering… ${pct}%`; });
      statusEl.innerHTML = `✓ Done! <a href="${esc(url)}" target="_blank" rel="noopener" class="hd-dl">⬇ Download / open</a>`;
      busy = false; goBtn.disabled = false; goBtn.textContent = "Render again";
    } catch (e) {
      busy = false; goBtn.disabled = false; statusEl.textContent = (e as Error).message;
    }
  });
}
